/*eslint-disable*/
import React, {useEffect, useState} from "react";
import {Link, NavLink as NavLinkRRD, Redirect} from "react-router-dom";
// nodejs library to set properties for components
import {func, PropTypes} from "prop-types";
import LocalizedStrings from "react-localization";
// reactstrap components
import {
    Button,
    Col,
    Collapse,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Media,
    Nav,
    Navbar,
    NavbarBrand,
    NavItem,
    NavLink,
    Row,
    UncontrolledDropdown
} from "reactstrap";
import {common_strings} from "../../translations/common_translations";
import {useObservable} from "../utils/observable/observableHook";
import {localeService} from "../utils/observable/services";
import businessHelper from "../../helpers/BusinessHelper";
import subscriptionHelpers from "../../helpers/SubscriptionHelper";
import {resource_strings} from "../../translations/resource_translations";
import SupportModal from "../Alerts/SupportModal";
import AppModal from "../Alerts/AppModal";
import {isMobile, isTablet} from "react-device-detect";
import lsHelpers from "../../helpers/LsHelper";
import businessApiService from "../../api/business-api-service";
import LocaleModal from "../Alerts/LocaleModal";

const commonStrings = new LocalizedStrings(common_strings);
const resourceStrings = new LocalizedStrings(resource_strings);

const Sidebar = (props) => {

    const locale = useObservable(localeService.locale);
    const [collapseOpen, setCollapseOpen] = useState(false);
    const [business, setBusiness] = useState(businessHelper.business());
    const [showSupport, setShowSupport] = useState(false);
    const [showMobile, setShowMobile] = useState(false);
    const [exit, setExit] = useState(false);
    const [sidebarIsVisible, setSidebarIsVisible] = useState(false);
    const [locales, setLocales] = useState([]);
    const [showLocales, setShowLocales] = useState(false);

    useEffect(() => {
        getUser()
        window.addEventListener('locale_set', updateUserData);

        return () => {
            // Do unmounting stuff here
            window.removeEventListener('locale_set', updateUserData);
        };
    }, []);

    function getUser() {
        businessApiService.current()
            .then(res => {
                setBusiness(res.user)
                setLocales(res.locales)
            })
            .catch((e) => {
                console.log(e.message ? e.message : "")
            });
    }

    function currentLocaleName() {
        if (locales && locales.length > 0) {
            const fixedLocale = locales.find((l) => {
                return l.fixed
            })

            if (fixedLocale) {
                return fixedLocale.title
            } else {
                const loc_id = businessHelper.currentLocale();
                const curLocale = locales.find((l) => {
                    return parseInt(l.id) == parseInt(loc_id)
                })

                if (curLocale) {
                    return curLocale.title
                } else {
                    return locales[0].title
                }
            }
        }
    }

    function showLocaleOptions(e) {
        if (e) e.preventDefault();

        if (locales && locales.length > 0) {
            const fixedLocale = locales.find((l) => {
                return l.fixed
            })

            if (fixedLocale) {
                return null
            } else {
                setShowLocales(true)
            }
        }
    }

    function selectLocale(e, locale) {
        if (e) e.preventDefault();
        businessHelper.saveCurrentLocale(locale.id);
        toggleLocaleModal()
        window.location.reload()
    }

    const toggleLocaleModal = () => {
        setShowLocales(!showLocales)
    };

    function updateUserData() {
        setBusiness(businessHelper.business())
        reloadLocales()
    }

    function reloadLocales() {
        businessApiService.current()
            .then(res => {
                setLocales(res.locales)
            })
            .catch((e) => {
                console.log(e.message ? e.message : "")
            });
    }

    // verifies if routeName is the one active (in browser input)
    function activeRoute(routeName) {
        return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    }

    // toggles collapse between opened and closed (true/false)
    const toggleCollapse = () => {
        setCollapseOpen(!collapseOpen);
    };
    // closes the collapse
    const closeCollapse = () => {
        setCollapseOpen(false)
    };

    function logout(e) {
        lsHelpers.logout()

        setExit(true)
        e.preventDefault()
    };

    function toSubscriptions(e) {
        e.preventDefault();
    };

    function isSidebarVisible() {
        if (!isMobile && !isTablet) {
            return true
        } else return sidebarIsVisible
    }

    const hiddenPages = [
        "Client overview",
        "Teacher overview",
        "Class Overview",
        "Register",
        "Password reset",
        "Subscriptions",
        "Welcome",
        "Clients_",
        "Dashboard_",
        "N_",
        "Subscriptions_"
    ];

    function routeMustBeShown(prop) {
        return !hiddenPages.includes(prop.name)
    }

    // creates the links that appear in the left menu / Sidebar
    const createLinks = routes => {
        return routes.map((prop, key) => {
            return (
                <NavItem key={key}>
                    {routeMustBeShown(prop) &&
                    <NavLink
                        to={prop.layout + prop.path}
                        tag={NavLinkRRD}
                        onClick={closeCollapse}
                        activeClassName="active"
                    >
                        <i className={prop.icon}/>
                        {translateItem(prop.name)}
                    </NavLink>
                    }
                </NavItem>
            );
        });
    };


    commonStrings.setLanguage(locale);
    resourceStrings.setLanguage(locale);

    const {bgColor, routes, logo} = props;
    let navbarBrandProps;
    if (logo && logo.innerLink) {
        navbarBrandProps = {
            to: logo.innerLink,
            tag: Link
        };
    } else if (logo && logo.outterLink) {
        navbarBrandProps = {
            href: logo.outterLink,
            target: "_blank"
        };
    }

    function showSupportModal(e) {
        e.preventDefault();
        setShowSupport(true)
    }

    function showMobileModal(e) {
        e.preventDefault();
        setShowMobile(true)
    }

    const toggleSupportModal = () => {
        setShowSupport(!showSupport)
    };

    const toggleMobileModal = () => {
        setShowMobile(!showMobile)
    };

    function getLogo() {
        return business && business.logo ? business.logo : require("assets/img/theme/open-logo-gray.png");
    }

    if (exit === true) return <Redirect from="*" to="/auth/login"/>

    return (
        <>
            {showLocales === true &&
            <LocaleModal toggleModal={toggleLocaleModal} locales={locales} setLocale={selectLocale}/>
            }

            <Navbar
                className="navbar-vertical fixed-left navbar-dark"
                expand="md"
                light={true}
                id="sidenav-main"
            >
                {showSupport === true &&
                <SupportModal toggleModal={toggleSupportModal}/>
                }

                {showMobile === true &&
                <AppModal toggleAppModal={toggleMobileModal} showAppModal={showMobile}/>
                }

                <Container fluid>
                    {/* Toggler */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={toggleCollapse}
                    >
                        <span className="navbar-toggler-icon"/>
                    </button>
                    {/* Brand */}
                    {logo ? (
                        <NavbarBrand className="pt-0" {...navbarBrandProps}>
                            <div className="d-flex">
                                <img
                                    alt={logo.imgAlt}
                                    className="navbar-brand-img"
                                    src={logo.imgSrc}
                                />

                                <img
                                    alt="..."
                                    width={30}
                                    style={{marginBottom: 10, marginLeft: 4}}
                                    height={"auto"}
                                    src={require("assets/img/brand/ukraine.png")}/>

                                {window.innerWidth > 450 &&
                                <div className="text-right pull-right"
                                     style={{width: "100%", display: "block", alignItems: "center"}}>
                                    <Button size="sm" onClick={e => props.toggleSideBar(e)}><i
                                        className="fas fa-chevron-circle-left"/></Button>
                                </div>
                                }
                            </div>
                        </NavbarBrand>
                    ) : null}
                    {/* User */}
                    {/*<ReactTooltip/>*/}
                    <Nav className="align-items-center d-md-none">
                        {locales && locales.length > 1 ?
                            (<Button style={{padding: 4}}
                                     onClick={e => showLocaleOptions(e)}>{currentLocaleName()}</Button>)
                            :
                            (<Button
                                style={{paddingTop: 4, paddingBottom: 4}}
                                color="secondary"
                                size="sm"
                                data-type="dark"
                                place="bottom"
                                data-tip={commonStrings.navigation.manage_subscription_expl}
                                className="d-md-flex"
                                onClick={e => toSubscriptions(e)}
                            >
                                <div
                                    className="description">{subscriptionHelpers.subscriptionPlan()}
                                </div>
                            </Button>)
                        }
                        <UncontrolledDropdown nav>
                            <DropdownToggle nav>
                                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img
                        alt="..."
                        src={getLogo()}
                    />
                  </span>
                                </Media>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-arrow" right>
                                <DropdownItem className="noti-title" header tag="div">
                                    <h6 className="text-overflow m-0"></h6>
                                </DropdownItem>
                                <DropdownItem to="/admin/user-profile" tag={Link}>
                                    <i className="ni ni-settings-gear-65"/>
                                    <span>{commonStrings.navigation.profile}</span>
                                </DropdownItem>
                                <DropdownItem onClick={(e) => showSupportModal(e)} tag={Link}>
                                    <i className="ni ni-support-16"/>
                                    <span>{commonStrings.navigation.support}</span>
                                </DropdownItem>
                                <DropdownItem divider/>
                                <DropdownItem onClick={(e) => logout(e)}>
                                    <i className="ni ni-user-run"/>
                                    <span>{commonStrings.navigation.logout}</span>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </Nav>
                    {/* Collapse */}
                    <Collapse navbar isOpen={collapseOpen}>
                        {/* Collapse header */}
                        <div className="navbar-collapse-header d-md-none">
                            <Row>
                                {logo ? (
                                    <Col className="collapse-brand" xs="6">
                                        {logo.innerLink ? (
                                            <Link to={logo.innerLink}>
                                                <img src={getLogo()}/>
                                            </Link>
                                        ) : (
                                            <a href={logo.outterLink}>
                                                <img alt={logo.imgAlt} src={logo.imgSrc}/>
                                            </a>
                                        )}
                                    </Col>
                                ) : null}
                                <Col className="collapse-close" xs="6">
                                    <button
                                        className="navbar-toggler"
                                        type="button"
                                        onClick={toggleCollapse}
                                    >
                                        <span/>
                                        <span/>
                                    </button>
                                </Col>
                            </Row>
                        </div>
                        {/* Form */}
                        {/*<Form className="mt-4 mb-3 d-md-none">*/}
                        {/*    <InputGroup className="input-group-rounded input-group-merge">*/}
                        {/*        <Input*/}
                        {/*            aria-label="Search"*/}
                        {/*            className="form-control-rounded form-control-prepended"*/}
                        {/*            placeholder="Search"*/}
                        {/*            type="search"*/}
                        {/*        />*/}
                        {/*        <InputGroupAddon addonType="prepend">*/}
                        {/*            <InputGroupText>*/}
                        {/*                <span className="fa fa-search"/>*/}
                        {/*            </InputGroupText>*/}
                        {/*        </InputGroupAddon>*/}
                        {/*    </InputGroup>*/}
                        {/*</Form>*/}
                        {/* Navigation */}
                        <Nav navbar>{createLinks(routes)}</Nav>
                        {/* Divider */}
                        <hr className="my-3"/>
                        {/* Heading */}
                        <h6 className="navbar-heading text-muted">{commonStrings.navigation.documentation}</h6>
                        {/* Navigation */}
                        <Nav className="mb-md-3" navbar>
                            <NavItem>
                                <NavLink
                                    to={"/admin/about"}
                                    tag={NavLinkRRD}
                                    onClick={closeCollapse}>
                                    <i className="fas fa-info-circle"/>
                                    {commonStrings.navigation.how_to_use}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    href=""
                                    onClick={(e) => showMobileModal(e)}>
                                    <i className="fas fa-mobile-alt"/>
                                    {commonStrings.navigation.mobile_app}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    href=""
                                    onClick={(e) => showSupportModal(e)}>
                                    <i className="fas fa-envelope"/>
                                    {commonStrings.navigation.support}
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <Nav className="mb-md-3" navbar>
                            <NavItem className="active-pro" style={{background: "rgba(255, 255, 255, 0.1)"}}>
                                <NavLink
                                    to={"/admin/subscriptions"}
                                    tag={NavLinkRRD}
                                    onClick={closeCollapse}
                                >
                                    <i className="ni ni-spaceship"/>
                                    {subscriptionHelpers.hasSubscription() ? resourceStrings.subscriptions.manage_subscription : resourceStrings.subscriptions.upgrade_to_pro}
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <label className="navbar-heading text-muted text-sm">2.4.0</label>
                    </Collapse>
                </Container>
            </Navbar>
        </>
    );

    function translateItem(name) {
        switch (name) {
            case "Dashboard":
                return commonStrings.navigation.dashboard;
            case "Profile":
                return commonStrings.navigation.profile;
            case "Client overview":
                return commonStrings.navigation.client_overview;
            case "Reports":
                return commonStrings.navigation.reports;
            case "Client App":
                return resourceStrings.public_profile.public_profile;
            case "Clients":
                return commonStrings.navigation.clients;
            case "Logout":
                return commonStrings.navigation.logout;
            case "Schedule":
                return commonStrings.navigation.schedule;
            case "Cabinet":
                return commonStrings.navigation.cabinet;
        }
    }
};

Sidebar.defaultProps = {
    routes: [{}]
};

Sidebar.propTypes = {
    // links that will be displayed inside the component
    routes: PropTypes.arrayOf(PropTypes.object),
    logo: PropTypes.shape({
        // innerLink is for links that will direct the user within the app
        // it will be rendered as <Link to="...">...</Link> tag
        innerLink: PropTypes.string,
        // outterLink is for links that will direct the user outside the app
        // it will be rendered as simple <a href="...">...</a> tag
        outterLink: PropTypes.string,
        // the image src of the logo
        imgSrc: PropTypes.string.isRequired,
        // the alt for the img
        imgAlt: PropTypes.string.isRequired
    })
};

export default Sidebar;
